import { WIDGET_ACTIONS, COOKIES } from './types';
import { DISPLAY } from '../../main/types';

const initialState = {
    isInitView: true,
    currentView: null,
    currentMode: null,
    widgetDisplay: DISPLAY.NONE,
    width: null,
    height: null,
    inviteResultSend: false,
    isUsabilaCookiePresent: false
};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case WIDGET_ACTIONS.INIT:
            return {
                isInitView: action.data.isInitView,
                currentView: action.data.currentView,
                currentMode: action.data.currentMode,
                widgetDisplay: action.data.widgetDisplay,
                width: action.data.width,
                height: action.data.height,
                isUsabilaCookiePresent: action.data.isUsabilaCookiePresent
            };
        case WIDGET_ACTIONS.OPEN:
            return {
                ...state,
                currentView: action.data.view,
                currentMode: action.data.mode,
                widgetDisplay: action.data.widgetDisplay
            };
        case WIDGET_ACTIONS.CLOSE:
            return initialState;
        case WIDGET_ACTIONS.RESIZE:
            return {
                ...state,
                width: action.data.width ? action.data.width : state.width,
                height: action.data.height ? action.data.height : state.height,
                widgetDisplay: action.data.widgetDisplay
            };
        case WIDGET_ACTIONS.SWITCH:
            return {
                ...state,
                isInitView: !state.currentView ? true : false,
                currentView: action.data.view ? action.data.view : state.currentView,
                currentMode: action.data.mode,
                widgetDisplay: action.data.widgetDisplay
            };
        case WIDGET_ACTIONS.INVITE_RESULT_SEND:
            return {
                ...state,
                inviteResultSend: true
            };
        case COOKIES.CHECK_USABILA:
            return {
                ...state,
                isUsabilaCookiePresent: action.data.isPresent
            };
        default:
            return state;
    }
};

export default reducer;
